import { useStaticQuery, graphql } from 'gatsby'

export const useResultsInteriorQuery = () => {
const postListData = useStaticQuery(
    graphql`
    query ResultsInteriorQuery {
      criminalDefense: allWpCaseresult(filter: {categories: {nodes: {elemMatch: {id: {eq: "dGVybTo4Mg=="}}}}}) {
        edges {
          node {
            advancedcustomfieldscaseresults {
              caseResultsAmount
              caseResultsSubtitle
              caseResultsTabContent
            }
          }
        }
      }
      personalInjury: allWpCaseresult(filter: {categories: {nodes: {elemMatch: {id: {eq: "dGVybTo4Ng=="}}}}}) {
        edges {
          node {
            advancedcustomfieldscaseresults {
              caseResultsAmount
              caseResultsSubtitle
              caseResultsTabContent
            }
          }
        }
      }
      familyLaw: allWpCaseresult(filter: {categories: {nodes: {elemMatch: {id: {eq: "dGVybTo4OQ=="}}}}}) {
        edges {
          node {
            advancedcustomfieldscaseresults {
              caseResultsAmount
              caseResultsSubtitle
              caseResultsTabContent
            }
          }
        }
      }
    }
  `
);
return postListData;
}